import {catchError, from, map, Observable, switchMap, tap} from 'rxjs';
import {AxiosError, AxiosResponse} from 'axios';
import {setEntities} from '@ngneat/elf-entities';

import {ContainersPagination, ManageContainer} from '@store/settings/containers/containers.model';
import {containersStore} from '@store/settings/containers/containers.store';
import {getContainersDataSource} from '@store/settings/containers/containers.requests';

import APIAxios, {APIRoutes} from '@api/axios.api';
import SnackError from '@utils/error.utils';
import {TableConfig} from '@constants/table.constants';

export class ContainersService {
  store = containersStore;

  resetStore = () => this.store.reset();

  searchContainers = (search?: string): Observable<ContainersPagination> => {
    return from(APIAxios({
      ...APIRoutes.GETContainers(),
      params: {
        searchString: search || undefined,
        page: 1,
        limit: TableConfig.pagination,
      },
    }))
      .pipe(
        catchError((err: AxiosError) => {
          throw new SnackError((err.response as any)?.data?.message, 'error');
        }),
        map((response: AxiosResponse<ContainersPagination>) => {
          return response.data;
        }),
      );
  };

  getContainers = (): Observable<ContainersPagination> => {
    return from(APIAxios({
      ...APIRoutes.GETContainers(),
      params: {disablePaginate: true},
    }))
      .pipe(
        catchError((err: AxiosError) => {
          throw new SnackError((err.response as any)?.data?.message, 'error');
        }),
        map((response: AxiosResponse<ContainersPagination>) => {
          return response.data;
        }),
        tap((containersPagination) => {
          this.store.update(
            setEntities(containersPagination.data),
            getContainersDataSource.setSuccess(),
          );
        }),
        getContainersDataSource.trackRequestStatus(),
      );
  };

  createContainer = (data: ManageContainer): Observable<ContainersPagination> => {
    return from(APIAxios({
      ...APIRoutes.POSTContainer(),
      data,
    }))
      .pipe(
        catchError((err: AxiosError) => {
          throw new SnackError((err.response as any)?.data?.message, 'error');
        }),
        switchMap(() => this.getContainers()),
      );
  };

  updateContainer = (containerId: number | string, data: ManageContainer): Observable<ContainersPagination> => {
    return from(APIAxios({
      ...APIRoutes.PUTContainer(containerId),
      data,
    }))
      .pipe(
        catchError((err: AxiosError) => {
          throw new SnackError((err.response as any)?.data?.message, 'error');
        }),
        switchMap(() => this.getContainers()),
      );
  };

}

export const containersService = new ContainersService();
